module.exports = __webpack_public_path__ + "static/img/apply_banner_01.b7e8768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/apply_banner_01.png
// module id = aggY
// module chunks = 34